const average = (items) => {
    let total = 0
    items.forEach(element => total += element)
    return Math.round(total / items.length)
}
export default average